import styled from "styled-components";
import colors from "../../theme/colors";

export const Wrapper = styled.div`
  background-color: ${colors.gray};
  width: 100%;
  height: 100%;
  border-radius: 4px;
  canvas {
    outline: 0px;
  }
`;
